<div aria-busy="true" aria-live="polite" class="relative" role="status">
	<div aria-hidden="true">
		<div
			class="hero min-h-80 max-md:aspect-[7/6] md:h-[58vw] md:max-h-200 md:min-h-112"
		>
			<div class="h-[640px]"></div>
		</div>
		<div class="section-spacing">
			<div class="section-inner section-gap flex flex-col">
				<div
					class="grid grid-cols-1 items-start gap-8 md:[grid-template-columns:2fr_1fr]"
				>
					<section class="panel space-y-6">
						<div class="space-y-3">
							<div class="w-28 skel-pill"></div>
							<div class="w-2/3 skel-title"></div>
							<div class="grid gap-2.5">
								<div class="w-full skel-line-lg"></div>
								<div class="w-11/12 skel-line-lg"></div>
								<div class="w-10/12 skel-line-lg"></div>
							</div>
						</div>
						<div class="space-y-4">
							<div class="skel h-6 w-48 rounded-xl"></div>
							<div class="w-64 skel-line-lg"></div>

							<div class="grid gap-3">
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="size-5 skel-dot"></div>
									<div class="w-2/3 skel-line-lg"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="size-5 skel-dot"></div>
									<div class="w-3/5 skel-line-lg"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="size-5 skel-dot"></div>
									<div class="w-1/2 skel-line-lg"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="size-5 skel-dot"></div>
									<div class="w-7/12 skel-line-lg"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="size-5 skel-dot"></div>
									<div class="w-2/3 skel-line-lg"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="size-5 skel-dot"></div>
									<div class="w-1/2 skel-line-lg"></div>
								</div>
							</div>
						</div>
						<div class="space-y-4">
							<div class="skel h-6 w-44 rounded-xl"></div>

							<div class="flex flex-wrap gap-2">
								<div class="w-28 skel-chip"></div>
								<div class="w-32 skel-chip"></div>
								<div class="w-24 skel-chip"></div>
							</div>

							<div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
								<div
									class="grid grid-cols-[16px_1fr] items-center gap-3"
								>
									<div class="size-4 skel-dot"></div>
									<div class="w-3/4 skel-line"></div>
								</div>
							</div>

							<div class="skel h-9 w-40 rounded-full"></div>
						</div>
						<div class="space-y-4">
							<div class="skel h-6 w-56 rounded-xl"></div>
							<div class="grid gap-3">
								<div
									class="grid grid-cols-[16px_1fr] items-start gap-3"
								>
									<div class="mt-1 size-3 skel-dot"></div>
									<div class="w-11/12 skel-line"></div>
								</div>
							</div>
						</div>
					</section>
					<aside class="panel space-y-5">
						<div class="w-2/3 skel-title"></div>
						<div class="w-40 skel-line"></div>

						<div class="space-y-2">
							<div class="w-44 skel-line"></div>
							<div class="w-52 skel-line"></div>
						</div>

						<div class="grid grid-cols-2 gap-3">
							<div class="skel h-11 w-full rounded-lg"></div>
							<div class="skel h-11 w-full rounded-lg"></div>
						</div>

						<div class="skel h-10 w-full rounded-lg"></div>
						<div class="skel h-12 w-full rounded-xl"></div>

						<div class="grid gap-2">
							<div class="w-28 skel-line"></div>
							<div class="w-56 skel-line"></div>
						</div>
					</aside>
				</div>
			</div>
		</div>
	</div>
</div>
